import $ from 'jquery';

$(function () {

    const $window = $(window);


    /**
     * Header nav menu
     */

    // Main nav
    const $nav = $('header .header-nav');
    const $firstLevelParents = $nav.children('ul').children('li.has-submenu');
    // const $secondLevelParents = $firstLevelParents.children('ul').children('li.has-submenu');
    const $secondLevelParents = $firstLevelParents.find('li.has-submenu');

    // Mobile nav
    const $mobileNavPlaceholder = $('header .mobile-nav-placeholder');
    const $mobileNav = $nav.clone();
    const $mobileParents = $mobileNav.find('li.has-submenu');
    const $mobileLanguageChanger = $('header .header-language-changer').clone();
    const $burgerButton = $('header .burger-button');
    $mobileNavPlaceholder.append($mobileNav);
    $mobileNavPlaceholder.append($mobileLanguageChanger);

    $firstLevelParents.each(function () {

        const $parent = $(this);
        const $child = $parent.children('ul');
        const $link = $parent.children('a');

        $parent.on('nxb:open', function (event) {
            event.stopPropagation();
            event.preventDefault();
            // Open self
            $parent.addClass('open');
            $child.addClass('open');
            $link.addClass('hover');
            $child.fadeIn(250);
        });

        $parent.on('nxb:close', function (event) {
            event.stopPropagation();
            event.preventDefault();
            $parent.removeClass('open');
            $child.removeClass('open');
            $link.removeClass('hover');
            $child.fadeOut(250);
        });

        $parent.on('mouseleave', function (event){
            event.preventDefault();
            $parent.trigger('nxb:close');
        });

        $link.on('mouseover', function (event) {
            event.preventDefault();
            $parent.trigger('nxb:open');
        });
    });


    $secondLevelParents.add($mobileParents).each(function () {

        const $parent = $(this);
        const $child = $parent.children('ul');
        const $link = $parent.children('a');

        // Initially open, when current or parent is current
        if ($parent.hasClass('nav-state-active')) {
            $parent.addClass('open');
            $child.addClass('open');
        }

        $parent.on('nxb:open', function (event) {
            event.stopPropagation();
            event.preventDefault();
            // Open self
            $parent.addClass('open');
            $child.slideDown(250, function () {
                $child.addClass('open');
            });

            // Close all other siblings
            $parent.siblings('li.has-submenu').trigger('nxb:close');
        });

        $parent.on('nxb:close', function (event) {
            event.stopPropagation();
            event.preventDefault();
            $parent.removeClass('open');
            $child.slideUp(250, function () {
                $child.removeClass('open');
            });
        });


        if ($parent.hasClass('has-submenu')) {

            $link.on('click', function (event) {

                // Only open on first click. Trigger the link on the second.
                if (!$parent.hasClass('open')) {
                    event.preventDefault();
                    $parent.trigger('nxb:open');
                }
            });
        }



    });

    // Handle burger button and open/close the mobile menu
    $burgerButton.on('click', function (event) {
        event.preventDefault();

        if ($mobileNav.hasClass('open')) {
            $mobileNav.removeClass('open');
            $mobileNavPlaceholder.slideUp(400, function () {
                $mobileNavPlaceholder.removeClass('open');
            });
            $burgerButton.removeClass('active');
        } else {
            $mobileNav.addClass('open');
            $mobileNavPlaceholder.slideDown(400, function () {
                $mobileNavPlaceholder.addClass('open');
            });
            $burgerButton.addClass('active');
        }
    });


    $('header').each(function () {

        const $header = $(this);
        let narrowed = false;

        function onScroll() {
            const scrollTop = $window.scrollTop();

            if (scrollTop > 48) {
                if (narrowed) {
                    return;
                }
                $header.addClass('narrowed');
                narrowed = true;
            } else {
                if (!narrowed) {
                    return;
                }
                $header.removeClass('narrowed');
                narrowed = false;
            }
        }

        $window.on('scroll', function () {
            onScroll();
        });
        onScroll();

    });


});
